export default "__VITE_ASSET__7394e062__"